import { superAdminRoles } from "../utils/constant";
import useAccountQuery from "./useAccountQuery";
import useIsRole from "./useIsRole";

// use for Appsmen Admin

const useIsSuperAdmin = () => {
  const { data: account } = useAccountQuery();
  const isAdmin = useIsRole(account?.roles, superAdminRoles);
  return isAdmin;
};

export default useIsSuperAdmin;
